import React, { useState, useEffect, useRef } from "react";

import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
} from "@mui/material";
import { AddCircle, Delete } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const selectFieldStyles = {
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: "#909090",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#000000",
    borderWidth: "thin",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#9a00ed",
    borderWidth: "thin",
  },
};

const ContactSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Muito curto!")
    .max(50, "Muito longo!")
    .required("Digite um nome!"),
  text: Yup.string()
    .min(2, "Muito curto!")
    .max(50, "Muito longo!")
    .required("Digite uma mensagem!"),
});

const FlowBuilderMenuModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);

  const [rule, setRule] = useState();

  const [textDig, setTextDig] = useState("");
  const [nodeName, setNodeName] = useState("");

  const [arrayOption, setArrayOption] = useState([]);

  const [valueRadioButton, setValueRadionButton] = useState("number");

  const [listTitle, setListTitle] = useState("");
  const [listButtonText, setListButtonText] = useState("");
  const [listFooter, setListFooter] = useState("");

  const [labels, setLabels] = useState({
    title: i18n.t("flowBuilder.menus.addTitle") || "Adicionar menu ao fluxo",
    btn: i18n.t("common.add") || "Adicionar",
  });

  useEffect(() => {
    console.log(data);
    if (open === "edit") {
      setLabels({
        title: i18n.t("flowBuilder.menus.editTitle") || "Editar menu",
        btn: i18n.t("common.save"),
      });
      setTextDig(data?.data?.message || "");
      setNodeName(data?.data?.name || "");
      setArrayOption(data?.data?.arrayOption || []);
      setValueRadionButton(data?.data?.typeMenu || "number");
      setListTitle(data?.data?.listTitle || "");
      setListButtonText(data?.data?.listButtonText || "");
      setListFooter(data?.data?.listFooter || "");

      setActiveModal(true);
    } else if (open === "create") {
      setLabels({
        title: i18n.t("flowBuilder.menus.addTitle") || "Adicionar menu ao fluxo",
        btn: i18n.t("common.add") || "Adicionar",
      });
      setTextDig("");
      setNodeName("");
      setArrayOption([]);
      setValueRadionButton("number");
      setListTitle("");
      setListButtonText("");
      setListFooter("");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = async () => {
    console.log("[DEBUG MENU MODAL] Saving Menu Data:", {
      text: textDig,
      name: nodeName,
      type: valueRadioButton,
      options: arrayOption?.length,
      listTitle: listTitle,
      listButtonText: listButtonText,
      listFooter: listFooter
    });
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: {
          ...data.data,
          message: textDig,
          name: nodeName,
          arrayOption: arrayOption,
          typeMenu: valueRadioButton,
          listTitle: listTitle,
          listButtonText: listButtonText,
          listFooter: listFooter
        },
      });
      return;
    } else if (open === "create") {
      handleClose();
      onSave({
        message: textDig,
        name: nodeName,
        arrayOption: arrayOption,
        typeMenu: valueRadioButton,
        listTitle: listTitle,
        listButtonText: listButtonText,
        listFooter: listFooter
      });
    }
  };

  const removeOption = (number) => {
    setArrayOption((old) => (Array.isArray(old) ? old.filter((item) => item?.number !== number) : []));
  };

  const handleChangeRadionButton = (event) => {
    setValueRadionButton(event.target.value);
    console.log(event.target.value);
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title">{labels.title}</DialogTitle>
        <Stack>
          <Stack dividers style={{ gap: "8px", padding: "16px" }}>
            <Stack sx={{ padding: "20px 20px", display: "flex" }}>
              <RadioGroup
                defaultValue="numero"
                value={valueRadioButton}
                onChange={handleChangeRadionButton}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
                row
              >
                <FormControlLabel
                  value="number"
                  control={<Radio />}
                  label={i18n.t("flowBuilder.menus.fields.number") || "Número"}
                />
                <FormControlLabel
                  value="list"
                  control={<Radio />}
                  label={i18n.t("flowBuilder.menus.fields.list") || "Lista"}
                />
                <FormControlLabel
                  value="button"
                  control={<Radio />}
                  label={i18n.t("flowBuilder.menus.fields.button") || "Botão"}
                />
              </RadioGroup>
            </Stack>
            <TextField
              label="Nombre Interno"
              variant="outlined"
              value={nodeName}
              onChange={e => setNodeName(e.target.value)}
              margin="dense"
              fullWidth
              className={classes.textField}
              style={{ width: "100%", marginBottom: "15px" }}
              helperText="Nombre para identificar este nodo en el editor (ej. 'Bienvenida', 'Menú Principal')"
            />
            <TextField
              label={i18n.t("flowBuilder.menus.fields.messageLabel") || "Mensagem de explicação do menu"}
              rows={4}
              name="text"
              multiline
              variant="outlined"
              value={textDig}
              onChange={(e) => setTextDig(e.target.value)}
              style={{ width: "100%" }}
            />
            {valueRadioButton === "list" && (
              <Stack style={{ gap: "8px" }}>
                <TextField
                  label={i18n.t("flowBuilder.menus.fields.listTitle") || "Título da Lista"}
                  variant="outlined"
                  value={listTitle}
                  onChange={(e) => setListTitle(e.target.value)}
                  fullWidth
                />
                <TextField
                  label={i18n.t("flowBuilder.menus.fields.listButtonText") || "Texto do Botão"}
                  variant="outlined"
                  value={listButtonText}
                  onChange={(e) => setListButtonText(e.target.value)}
                  fullWidth
                />
                <TextField
                  label={i18n.t("flowBuilder.menus.fields.listFooter") || "Rodapé da Lista"}
                  variant="outlined"
                  value={listFooter}
                  onChange={(e) => setListFooter(e.target.value)}
                  fullWidth
                />
              </Stack>
            )}
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography>{i18n.t("flowBuilder.menus.fields.addOption") || "Adicionar Opção"}</Typography>
              <Button
                onClick={() =>
                  setArrayOption((old) => [
                    ...(Array.isArray(old) ? old : []),
                    { number: (old?.length || 0) + 1, value: "", description: "" },
                  ])
                }
                color="primary"
                variant="contained"
              >
                <AddCircle />
              </Button>
            </Stack>
            {(Array.isArray(arrayOption) ? arrayOption : []).map((item, index) => (
              <Stack width={"100%"} key={item?.number || index}>
                <Typography>{i18n.t("flowBuilder.menus.fields.enter") || "Digite"} {item?.number}</Typography>
                <Stack direction={"row"} width={"100%"} style={{ gap: "8px" }}>
                  <TextField
                    placeholder={i18n.t("flowBuilder.menus.fields.typeOption") || "Digite opção"}
                    variant="outlined"
                    defaultValue={item?.value || ""}
                    style={{ width: "100%" }}
                    onChange={(event) => {
                      const val = event.target.value;
                      setArrayOption((old) => {
                        let newArr = [...old];
                        if (newArr[index]) {
                          newArr[index] = { ...newArr[index], value: val };
                        }
                        return newArr;
                      });
                    }}
                  />
                  {arrayOption.length === item?.number && (
                    <IconButton onClick={() => removeOption(item?.number)}>
                      <Delete />
                    </IconButton>
                  )}
                </Stack>
              </Stack>
            ))}
          </Stack>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined" style={{ borderColor: "#ff4d4f", color: "#ff4d4f", textTransform: "none", fontWeight: "bold", borderRadius: "8px" }}>{i18n.t("common.cancel") || "Cancelar"}</Button>
            <Button type="submit" onClick={() => handleSaveContact()} variant="contained" style={{ backgroundColor: "#7367F0", color: "#fff", textTransform: "none", fontWeight: "bold", borderRadius: "8px", boxShadow: "0 4px 14px 0 rgba(115, 103, 240, 0.39)" }}>
              {`${labels.btn}`}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderMenuModal;
